import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Table,
  Spinner,
  Button,
} from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';

import { getNotifikasi } from '../../actions/NotifikasiAction';
import { DELETE_NOTIFIKASI, GET_TOKEN } from 'utils';

import swal from 'sweetalert';
import axios from 'axios';
import { logOutUser } from 'actions/AuthAction';
import jwt_decode from 'jwt-decode';

export default function ListNotifikasi() {
  const dispatch = useDispatch();
  const history = useHistory();

  const { getNotifikasiError, getNotifikasiLoading, getNotifikasiResult } =
    useSelector((state) => state.NotifikasiReducer);

  // auth

  const [token, setToken] = useState('');
  const [nama, setNama] = useState('');
  const [username, setUsername] = useState('');
  const [akses, setAkses] = useState('');
  const [expire, setExpire] = useState('');
  const [idAdmin, setIdAdmin] = useState('1');

  const refreshToken = async () => {
    try {
      const response = await axios.get(GET_TOKEN + '/token');
      setToken(response.data);
      const decoded = jwt_decode(response.data.accessToken);
      setNama(decoded.nama);
      setUsername(decoded.username);
      setAkses(decoded.akses.split(','));
      setExpire(decoded.exp);
      setIdAdmin(decoded.idAdmin);
    } catch (error) {
      if (error.response) {
        dispatch(logOutUser(history));
        history.push('/');
      }
    }
  };

  const axiosJWT = axios.create();

  axiosJWT.interceptors.request.use(
    async (config) => {
      const currentDate = new Date();
      if (expire * 1000 < currentDate.getTime()) {
        const response = await axios.get(GET_TOKEN + '/token');
        config.headers.Authorization = `Bearer ${response.data.accessToken}`;
        setToken(response.data.accessToken);
        const decoded = jwt_decode(response.data.accessToken);
        setNama(decoded.nama);
        setUsername(decoded.username);
        setAkses(decoded.akses);
        setIdAdmin(decoded.idAdmin);
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  //auth

  useEffect(() => {
    dispatch(getNotifikasi());
    refreshToken();
  }, []);

  const removeData = async (id) => {
    await axios.delete(DELETE_NOTIFIKASI + `${id}`);
    swal('Sukses!', 'Notifikasi berhasil dihapus', 'success');
    history.push('/admin');
    history.push('/admin/notifikasi');
  };

  return (
    <div className='content'>
      <Row>
        <Col md='12'>
          <Card>
            <CardHeader>
              <CardTitle tag='h4'>List Notifikasi</CardTitle>
              <Link
                to={'/admin/notifikasi/tambah/' + idAdmin}
                className='btn btn-primary float-right'
              >
                Tambah Notifikasi
              </Link>
            </CardHeader>
            <CardBody style={{ overflowX: 'auto' }}>
              <Table>
                <thead className='text-primary'>
                  <tr>
                    <th>Id</th>
                    <th>Foto</th>
                    <th>Judul</th>
                    <th>Sumber</th>
                    <th>Admin</th>
                    <th>Tanggal</th>
                    <th>Aksi</th>
                  </tr>
                </thead>

                <tbody>
                  {getNotifikasiResult ? (
                    Object.keys(getNotifikasiResult).map((key) => (
                      <tr key={key}>
                        <td>{getNotifikasiResult[key].id}</td>
                        <td>
                          <img
                            src={getNotifikasiResult[key].foto.split(',')[0]}
                            width='100'
                            alt={getNotifikasiResult[key].judul}
                          />
                        </td>
                        <td>{getNotifikasiResult[key].judul}</td>
                        <td>{getNotifikasiResult[key].sumber}</td>
                        <td>{getNotifikasiResult[key].idAdmin} </td>
                        <td>{getNotifikasiResult[key].dateTime} </td>
                        <td>
                          <Link
                            className='btn btn-warning'
                            to={
                              '/admin/notifikasi/edit/' +
                              getNotifikasiResult[key].id +
                              ',' +
                              idAdmin
                            }
                          >
                            <i className='nc-icon nc-ruler-pencil'></i> Edit
                          </Link>
                        </td>
                        <td>
                          <Button
                            color='danger'
                            className='ml-2'
                            onClick={() =>
                              removeData(getNotifikasiResult[key].id)
                            }
                          >
                            <i className='nc-icon nc-basket'></i> Hapus
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : getNotifikasiLoading ? (
                    <tr>
                      <td colSpan='6' align='center'>
                        <Spinner color='primary' />
                      </td>
                    </tr>
                  ) : getNotifikasiError ? (
                    <tr>
                      <td colSpan='6' align='center'>
                        {getNotifikasiError}
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td colSpan='6' align='center'>
                        Data Kosong
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
